import { useNavigation, useRoute } from "@react-navigation/native"
import { Button, CustomHeader, Screen, Text } from "components"
import { translate } from "i18n"
import React, { useEffect, useState } from "react"
import { View, ActivityIndicator, Platform } from "react-native"
import { style } from "./styles"
import { WebView } from "react-native-webview"
import { useColor } from "app/theme/getThemes"

export const WebViewScreen = () => {
  const route = useRoute()
  const { name } = route?.params
  const { companyTheme } = useColor()

  const [pdfURL, setPdfURL] = useState("")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getTerms()
  }, [])

  const getTerms = async () => {
    try {
      const res = await fetch(`${process.env.API_URL}/api/public/tnc/larrie`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })

      if (res.ok) {
        const response = await res.json()
        setPdfURL(response)
      } else {
        const errorMsg = await res.json()
        console.log(errorMsg)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const pdfLink = pdfURL
    ? name === "Tnc"
      ? pdfURL?.terms_n_condition
      : pdfURL?.privacy_policy
    : ""

  return (
    <>
      <CustomHeader
        headerTitle={name === "Tnc" ? "Terms and Conditions" : "Privacy Policy"}
        height={80}
        showBackButton
        withBalls
      />

      {loading ? (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <ActivityIndicator size="large" color={companyTheme.first} />
        </View>
      ) : Platform.OS === "web" ? (
        <iframe
          src={`https://docs.google.com/gview?embedded=true&url=${pdfLink}`}
          style={{ width: "100%", height: "100%", border: "none" }}
          title="WebView"
        />
      ) : (
        <WebView
          source={{
            uri:
              Platform.OS === "android"
                ? `https://docs.google.com/gview?embedded=true&url=${pdfLink}`
                : `${pdfLink}`,
          }}
          style={{ flex: 1 }}
        />
      )}
    </>
  )
}
